import { Grid } from '@mui/material';
import AuthenticatorContext from 'components/Authenticator/AuthenticatorContext';
import { MfaStatus } from 'lib/graphql/graphql';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import MfaMethodApp from './MfaMethods/MfaMethodApp';
import MfaRecoveryCodes from './MfaRecoveries/MfaRecoveryCodes';
import { MfaListContainer, MfaListHeader } from './styles';

export default function MfaList() {
  const { mfaStatus } = useContext(AuthenticatorContext);
  return (
    <MfaListContainer container direction="column" alignItems="flex-start">
      <MfaListHeader item>
        <Grid container justifyContent="space-between">
          <Grid item>
            <FormattedMessage id="mfa_methods" />
          </Grid>
        </Grid>
      </MfaListHeader>
      <MfaMethodApp />
      {mfaStatus === MfaStatus.Enabled && (
        <>
          <MfaListHeader item>
            <Grid container justifyContent="space-between">
              <Grid item>
                <FormattedMessage id="mfa_recovery_options" />
              </Grid>
            </Grid>
          </MfaListHeader>
          <MfaRecoveryCodes />
        </>
      )}
    </MfaListContainer>
  );
}
